import React from 'react';
import PropTypes from 'prop-types';
import { DEVICE } from '@/constants';
import { OS } from '@/utils/detectDevice';
import RecordingShareBtn from '../Lottie/RecordingShareBtn';
import './style.less';

class Recording extends React.Component {
  static propTypes = {
    callback: PropTypes.func,
    recordTxt: PropTypes.string,
  };

  constructor() {
    super();
    this.state = {
      recorder: null,
      recording: false,
      recordDis: false,
      playing: false,
      playDis: true,
      isPlay: false,
      phoneAudioRecorderSrc: undefined,
    };
    this.myRecorder = React.createRef();
  }

  componentWillMount() {
    this.getRecorder();
  }

  componentDidMount() {
    this.init();
    window.addEventListener('resize', this.resizeHandler);
  }

  componentWillUnmount() {
    this.state.recorder.destructor();
    window.removeEventListener('resize', this.resizeHandler);
  }

  getBtnStatus = () => {
    const { recording, playing } = this.state;
    return recording || playing;
  }

  changeBtnStatus = () => this.setState({ recordDis: true, playDis: true });

  init = () => {
    this.myRecorder.current.addEventListener('ended', () => {
      this.setState({
        playing: false,
        recordDis: false,
      });
    });
    // this.resizeHandler();
  };

  resizeHandler = () => {
    const question = document.querySelector('.recording-question');
    const style = window.getComputedStyle(question);
    const lineHeight = parseInt(style.lineHeight.slice(0, -2), 10);
    Math.round((question.clientHeight - 40) / lineHeight) > 4
      ? ((question.style.fontSize = '18px') && (question.style.lineHeight = '22px') && (question.style.padding = '10px'))
      : (question.style.fontSize = '22px');
  }

  getRecorder = async () => {
    const { default: Recorder } = OS.TYPE === DEVICE.PC
      ? await import('@/utils/recorderPc')
      : await import('@/utils/recorderPhone');
    const recorder = new Recorder(
      this.recorderResult,
      () => {},
      this.recorderStopPlayLocal,
      () => {},
      this.startRecordUI,
    );
    this.setState({ recorder });
  }

  startRecordUI = () => {
    this.setState({
      recording: true,
      recordDis: false,
      playDis: true,
    });
  };

  recorderStopPlayLocal = () => {
    this.setState({ playing: false, recordDis: false });
  };

  startRecord = (e) => {
    e.preventDefault();
    const { recorder, recording } = this.state;
    if (!recording) {
      this.props.callback('');
      recorder.start(this.props.recordTxt);
    } else {
      this.setState({ isPlay: true }, () => {
        recorder.stop();
      });
    }
  };

  play = (e) => {
    e.preventDefault();
    const { playing } = this.state;
    !playing ? this.startPlayMyRecording() : this.stopPlayMyRecording();
  };

  startPlayMyRecording = () => {
    const { recorder, phoneAudioRecorderSrc } = this.state;
    this.setState({ playing: true, recordDis: true, isPlay: true }, () => {
      recorder.play(phoneAudioRecorderSrc);
    });
  };

  stopPlayMyRecording = () => {
    this.setState({ playing: false, recordDis: false }, () => {
      const { recorder } = this.state;
      recorder.stopPlay();
    });
  };

  recorderResult = ({ src }) => {
    const { recorder: { recorder } } = this.state;
    const url = src || recorder.getSoundUrl();
    console.log('share result');
    this.setState({
      phoneAudioRecorderSrc: url,
      recording: false,
      playDis: !url,
    });
    this.props.callback(url);
  };

  endPlay = () => {
    const { isPlay } = this.state;
    this.setState({ playDis: !isPlay, playing: false, recordDis: false });
  }

  render() {
    const {
      recording,
      recordDis,
      playing,
      playDis,
      phoneAudioRecorderSrc,
    } = this.state;
    return (
      <div className="recording-wrapper">
        <div className="recording-question-wrapper">
          <div className="recording-question">
            {this.props.recordTxt}
          </div>
        </div>
        <div className="recording-btn">
          {recording
            ? <div className="share_record_animation" onClick={this.startRecord}><RecordingShareBtn /></div>
            : <div className={`share_record${recordDis ? ' dis' : ''}`} onClick={!recordDis ? this.startRecord : null} />
          }
          <div className={`share_play${playing ? ' animation' : ''}${playDis ? ' dis' : ''}`} onClick={!playDis ? this.play : null}>
            <div className={`${playing && !playDis ? 'share_playing' : ''}`} />
          </div>
        </div>
        <audio ref={this.myRecorder} src={phoneAudioRecorderSrc} />
      </div>
    );
  }
}

export default Recording;
